import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';


const StyledCard = styled((props) => (
  <Card {...props} />
))(({ theme }) => ({

    margin: '1rem',
    backgroundColor: theme.palette.grey.C050,
    borderColor: theme.palette.grey.C500,
    borderRadius: "12px",  
   
  [theme.breakpoints.up('xs')]: {
      width: 340,
      height: 'auto',
    },
  [theme.breakpoints.up('sm')]: {
    width: 340,
      height: 'auto',
    },
  [theme.breakpoints.up('md')]: {
    width: 340,
      height: 'auto',
   },
   [theme.breakpoints.up('lg')]: {
    width: 340,
      height: 'auto',
    },
  [theme.breakpoints.up('xl')]: {
    width: 500,
    height: 'auto',
    },

}));



export default function CardSmall(props) {
  
  const {headline, subtext, icon_1, icon_2, leftcontent, rightcontent, chart, textlines, cardlines, forms } = props

return(
<>

<StyledCard variant="outlined" >
    <CardContent>

     <Grid container>   
     
            <Grid size={12}> <Typography variant="h3" textAlign='left' gutterBottom sx={{color: 'common.black', }}>{headline} </Typography>  </Grid>
            
            <Grid size={12}> <Typography variant="body2" textAlign='left' gutterBottom sx={{pl: 0.5,color: 'common.black', }}>{subtext} </Typography>  </Grid>
            
            <Grid container sx={{width: '100%'}}>
            
                  <Grid size={5}>    
                    <Grid container direction="column">  
                    <Grid size={12}> <Stack direction="row"> {icon_1} {icon_2} </Stack></Grid>
                        <Grid  > {leftcontent} </Grid> 
                        <Grid  > {textlines} </Grid> 
                    </Grid>
                  </Grid>

                  <Grid size={7} sx={{display: 'flex',justifyContent: 'flex-start', alignItems: 'center' }}>     
                      <Grid container direction="column">     
                          <Grid >{chart}</Grid>
                          <Grid > {rightcontent} </Grid>
                      </Grid>
                  </Grid>      
            </Grid>
          
            <Grid size={12} sx={{pl:1, pt:2, }}>{ cardlines }</Grid>  
            <Grid size={12} sx={{display: 'flex', justifyContent: 'center' }}>{ forms }</Grid>  

     </Grid>        
    </CardContent>
</StyledCard>
</>
)
}

